import * as React from 'react';

import { useDispatch, useSelector } from 'react-redux';
import { Tags, useDeviceType } from '@cian/ui-kit';
import { extractJsonQueryAction } from '../../../../actions/jsonQuery';
import { selectSearchTags } from '../../../../selectors/tags';

export const SearchModalTagsContainer: React.FC = () => {
  const tags = useSelector(selectSearchTags);
  const dispatch = useDispatch();
  const deviceType = useDeviceType();

  const tagSize = React.useMemo(() => (deviceType === 'phone' ? 'M' : 'XS'), [deviceType]);
  const displayTags = React.useMemo(() => tags.map((tag, idx) => ({ label: tag.name, value: String(idx) })), [tags]);

  const handleTagClear = React.useCallback(
    ({ value }: { value: string }) => {
      const index = +value;
      const tag = tags[index];

      dispatch(extractJsonQueryAction(tag.jsonQuery));
    },
    [dispatch, tags],
  );

  return <Tags size={tagSize} options={displayTags} onClose={handleTagClear} />;
};
